import { Component, Input, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { IonItem, NavController } from '@ionic/angular';

@Component({
  selector: 'banner-grid',
  templateUrl: './banner-grid.component.html',
  styleUrls: ['./banner-grid.component.scss'],
})
export class BannerGridComponent implements OnInit {
  @Input() bannerList: any[];
  constructor(
    private navControl: NavController,
  ) { }

  ngOnInit() { }
  async navigate(item) {
    if (item.landingType === 'external') {
      await Browser.open({ url: item.url });
    } else {
      this.navControl.navigateForward('/membership/' + item.id);
    }
  }
}
